// extracted by mini-css-extract-plugin
export var arrow = "_h1-1";
export var content = "_h1-0";
export var highlighted = "_h1-2";